import { useMutation, useQuery } from '@apollo/client/react';
import {
  GET_VENDOR_STAFF,
  ADD_STAFF_TO_VENDOR,
  REMOVE_STAFF_FROM_VENDOR,
} from 'api/graphql/staff';
import { useVendor } from 'features/vendor';

/** Lists staff for the active vendor. */
export function useVendorStaff() {
  const { vendorId, loading: vendorLoading } = useVendor();

  const { data, loading, error, refetch } = useQuery(GET_VENDOR_STAFF, {
    variables: { vendorId },
    skip: !vendorId,
    notifyOnNetworkStatusChange: true,
  });

  return {
    staff: data?.getVendorStaff?.staff ?? [],
    loading: vendorLoading || loading,
    error,
    refetch,
  };
}

export function useAddStaff() {
  const { vendorId: activeVendorId } = useVendor();
  const [mutate, { loading }] = useMutation(ADD_STAFF_TO_VENDOR, {
    // Refresh the visible (active shop's) staff list.
    refetchQueries: activeVendorId
      ? [{ query: GET_VENDOR_STAFF, variables: { vendorId: activeVendorId } }]
      : [],
    awaitRefetchQueries: true,
  });

  // `vendorId` is the SHOP the staff is added to (defaults to the active shop).
  const addStaff = async ({ vendorId, phone, name }) => {
    const { data } = await mutate({
      variables: { vendorId: vendorId || activeVendorId, phone, name },
    });
    return data?.addStaffToVendor ?? null;
  };

  return { addStaff, loading };
}

export function useRemoveStaff() {
  const { vendorId } = useVendor();
  const [mutate, { loading }] = useMutation(REMOVE_STAFF_FROM_VENDOR, {
    refetchQueries: vendorId ? [{ query: GET_VENDOR_STAFF, variables: { vendorId } }] : [],
    awaitRefetchQueries: true,
  });

  const removeStaff = async (staffVendorId) => {
    const { data } = await mutate({ variables: { staffVendorId } });
    return data?.removeStaffFromVendor ?? null;
  };

  return { removeStaff, loading };
}
